export enum Endpoints {
  FetchInvite = '/v1/gigsafe/auth/invite/:inviteId',
  SignUp = '/v1/gigsafe/auth/sign-up',
  MCSignUp = '/v1/gigsafe/auth/master-contractor/sign-up',
  SignIn = '/v1/gigsafe/auth/sign-in',
  RefreshToken = '/v1/gigsafe/auth/refresh-token',
  ForgotPassword = '/v1/gigsafe/auth/forgot-password',
  ResetPassword = '/v1/gigsafe/auth/reset-password',

  FetchUser = '/v1/gigsafe/users/self',
  FetchUserNotificationsConfig = '/v1/gigsafe/reports-config',
  UpdateUserNotificationsConfig = '/v1/gigsafe/reports-config',

  FetchMarkets = '/v1/gigsafe/onboarding/dashboard/partner-markets',
  FetchOnboardingTemplates = '/v1/gigsafe/onboarding/dashboard/onboarding-templates',

  FetchOnboardingsCounts = '/v2/gigsafe/onboarding/dashboard/partner-drivers-onboardings-counts',
  FetchOnboardings = '/v2/gigsafe/onboarding/dashboard/partner-drivers-onboardings',
  FetchOnboarding = '/v1/gigsafe/onboarding/dashboard/partner-drivers-onboardings/:contractorId',
  FetchOnboardingDocuments = '/v1/gigsafe/onboarding/dashboard/onboarding-documents/:onboardingId',
  FetchOnboardingContracts = '/v1/gigsafe/onboarding/dashboard/onboarding-documents/:onboardingId/contracts',
  FetchRecollectingSteps = '/v1/gigsafe/document-recollection/steps/:partnerDriverId',
  SendRemainderOnboarding = '/v1/gigsafe/onboarding/dashboard/:partnerDriverId/send-reminder',

  FetchPayments = '/v1/gigsafe/payments/dashboard',
  UploadPaymentsCSV = '/v1/gigsafe/payments/dashboard/upload-earnings-csv',
  FetchPaymentInvoice = '/v1/gigsafe/payments/dashboard/invoice/:paymentId',
  DeletePayment = '/v1/gigsafe/payments/dashboard/earnings',
  CancelPayment = '/v1/gigsafe/payments/dashboard/earnings/:paymentId/cancel',
  ProcessPayments = '/v1/gigsafe/payments/dashboard/process-payments',
  ProcessPayment = '/v1/gigsafe/payments/dashboard/process-payment/:paymentId',
  ValidateSinglePayment = '/v1/gigsafe/payments/dashboard/validate-payment',
  AddSinglePayment = '/v1/gigsafe/payments/dashboard/create-payment',

  FetchMCPayments = '/v1/gigsafe/payments/master-contractor',
  UploadMCPaymentsCSV = '/v1/gigsafe/payments/master-contractor/upload-earnings-csv',
  FetchMCPaymentInvoice = '/v1/gigsafe/payments/master-contractor/invoice/:paymentId',
  DeleteMCPayment = '/v1/gigsafe/payments/master-contractor/earnings ',
  ProcessMCPayments = '/v1/gigsafe/payments/master-contractor/process-payments',
  ProcessMCPayment = '/v1/gigsafe/payments/master-contractor/process-payment/:paymentId',
  ValidateSingleMCPayment = '/v1/gigsafe/payments/master-contractor/validate-payment',
  AddSingleMCPayment = '/v1/gigsafe/payments/master-contractor/create-payment',

  FetchContractors = '/v1/gigsafe/dashboards/contractors',
  FetchContractorsCount = '/v1/gigsafe/dashboards/contractors/counts',
  FetchContractor = '/v1/gigsafe/dashboards/contractors/:contractorId',
  FetchSubcontractor = '/v1/gigsafe/dashboards/customer/subcontractor/details',
  SendRemainderContractor = '/v1/gigsafe/dashboards/contractors/:partnerDriverId/send-reminder',
  FetchContractorDeactivationDates = '/v1/gigsafe/dashboards/contractors/:partnerDriverId/deactivation-dates',
  SetContractorDeactivationDate = '/v1/gigsafe/dashboards/contractors/:partnerDriverId/scheduled-deactivation',
  FetchContractorActivitiesLogs = '/v1/gigsafe/onboarding/dashboard/:partnerDriverId/logs',
  FetchContractorSelfie = '/v1/gigsafe/dashboards/contractors/:contractorId/collected-data/:stepId/download-selfie',
  DownloadStepDocument = '/v1/gigsafe/dashboards/contractors/:partnerDriverId/collected-data/:stepId/documents/:documentId/download',

  FetchContractorNotes = '/v1/gigsafe/dashboards/contractors/:contractorId/notes',
  CreateContractorNote = '/v1/gigsafe/dashboards/contractors/:contractorId/notes',
  UpdateContractorNote = '/v1/gigsafe/dashboards/contractors/:contractorId/notes/:noteId',
  DeleteContractorNote = '/v1/gigsafe/dashboards/contractors/:contractorId/notes/:noteId',

  UploadPartnerDriversCSV = '/v1/gigsafe/onboarding/dashboard/bulk-invite',
  CreatePartnerDriver = '/v1/gigsafe/onboarding/dashboard/driver',
  // This one for updating markets
  UpdatePartnerDriver = '/v1/gigsafe/onboarding/dashboard/driver/:partnerDriverId',
  ActivatePartnerDriver = '/v1/gigsafe/onboarding/dashboard/driver/:partnerDriverId/activate',
  DeactivatePartnerDriver = '/v1/gigsafe/onboarding/dashboard/driver/:partnerDriverId/deactivate',
  FetchSensitiveData = '/v1/gigsafe/dashboards/contractors/driver/:partnerDriverId/steps/:stepId/additional-details',

  FetchTags = '/v1/gigsafe/tags',
  CreateTag = '/v1/gigsafe/tags',
  DeleteTag = '/v1/gigsafe/tags/:tagId',
  DriverAddTag = '/v1/gigsafe/tags/:tagId/driver',
  DriverDeleteTag = '/v1/gigsafe/tags/:tagId/driver',

  SubcontractorAddTag = '/v1/gigsafe/tags/:tagId/subcontractor',
  SubcontractorDeleteTag = '/v1/gigsafe/tags/:tagId/subcontractor',

  UpdateSubcontractorMarket = '/v1/gigsafe/dashboards/customer/subcontractor/update-market',
  UpdateSubcontractorExternalId = '/v1/gigsafe/dashboards/customer/subcontractor/external-id',

  RejectOnboarding = '/v1/gigsafe/onboarding/dashboard/reject-onboarding',
  UnrejectOnboarding = '/v1/gigsafe/onboarding/dashboard/reset-failed-steps',

  ApproveOnboardingStep = '/v1/gigsafe/onboarding/dashboard/approve-step',
  RecollectOnboardingStep = '/v1/gigsafe/onboarding/dashboard/recollect-step',
  UpdateCollectData = '/v1/gigsafe/onboarding/dashboard/:partnerDriverId/collected-data/:stepId',
  DeclineOnboardingStep = '/v1/gigsafe/onboarding/dashboard/decline-step',

  FetchRejectionReasonsToDecline = '/v1/gigsafe/onboarding/dashboard/review-rejection-reasons',
  FetchRejectionReasons = '/v1/gigsafe/dashboards/customer/review-rejection-reason',
  CreateRejectionReason = '/v1/gigsafe/dashboards/customer/review-rejection-reason',
  UpdateRejectionReason = '/v1/gigsafe/dashboards/customer/review-rejection-reason/:reasonId',
  DeleteRejectionReason = '/v1/gigsafe/dashboards/customer/review-rejection-reason/:reasonId',

  FetchDashboardsUpdates = '/v1/gigsafe/dashboards/updates/:type',
  FetchFailedPaymentsUpdates = '/v1/gigsafe/dashboards/updates/failed_payments',

  FetchTeamMembers = '/v1/gigsafe/users',
  FetchTeamMembersCount = '/v1/gigsafe/users/count',
  ActivateTeamMember = '/v1/gigsafe/users/activate',
  DeactivateTeamMember = '/v1/gigsafe/users/deactivate',
  FetchTeamMember = '/v1/gigsafe/users/:teamMemberId',
  UpdateTeamMemberAccess = '/v1/gigsafe/users/:teamMemberId/access',

  FetchTeamRoles = '/v1/gigsafe/roles',
  FetchTeamPermissions = '/v1/gigsafe/roles/permissions/all',
  CreateTeamRole = '/v1/gigsafe/roles',
  // TODO: editing is expected to be added in the next iterations
  UpdateTeamRole = '/v1/gigsafe/users/roles/:teamRoleId',
  DeleteTeamRole = '/v1/gigsafe/roles/:teamRoleId',

  FetchTeamMemberInvitesCount = '/v1/gigsafe/invites/count',
  FetchTeamMemberInvites = '/v1/gigsafe/invites',
  SendInviteToTeamMember = '/v1/gigsafe/invites',
  ResendTeamMemberInvite = '/v1/gigsafe/invites/:teamMemberInviteId/resend',
  FetchTeamMemberInvite = '/v1/gigsafe/invites/:teamMemberInviteId',
  UpdateTeamMemberInviteAccess = '/v1/gigsafe/invites/:teamMemberInviteId',

  FetchFundingSettings = '/v1/gigsafe/payments/dashboard/funding/settings',
  FetchFundingInvoice = '/v1/gigsafe/payments/dashboard/funding/current-invoice',
  CancelFundingInvoice = '/v1/gigsafe/payments/dashboard/funding/invoice/:composedInvoiceId/cancel',
  DownloadFundingInvoice = '/v1/gigsafe/payments/dashboard/funding/invoice/:composedInvoiceId/download',
  ResetFundingInvoice = '/v1/gigsafe/payments/dashboard/funding/invoice/:composedInvoiceId/reset',
  SubmitFundingMethodRequest = '/v1/gigsafe/payments/dashboard/funding/offer/:fundingType',
  SubmitFundingInvoiceRequest = '/v1/gigsafe/payments/dashboard/funding/invoice/:composedInvoiceId/confirm',
  FetchCustomerProfile = '/v1/gigsafe/dashboards/customer/profile',
  FetchPaymentsSummary = '/v1/gigsafe/payments/dashboard/funding',

  CustomerUploadBusinessInformation = '/v1/gigsafe/dashboards/customer/profile/business-information',
  CustomerUploadInsurance = '/v1/gigsafe/dashboards/customer/profile/insurance',
  CustomerUploadUpdatedInsurance = '/v1/gigsafe/dashboards/customer/profile/update-insurance',
  CustomerUploadBusinessDetails = '/v1/gigsafe/dashboards/customer/profile/business-details',
  CustomerUploadUpdatedBusinessDetails = '/v1/gigsafe/dashboards/customer/profile/update-business-details',
  CustomerUploadTSA = '/v1/gigsafe/dashboards/customer/profile/tsa',
  CustomerUploadUpdatedTSA = '/v1/gigsafe/dashboards/customer/profile/update-tsa',
  CustomerUploadPaymentMethod = '/v1/gigsafe/dashboards/customer/profile/payment-method',

  FetchCustomerDocusignSigningEnvelopeOptions = '/v1/gigsafe/dashboards/customer/profile/signing-envelope-options',
  CustomerDocusignStartSigning = '/v1/gigsafe/dashboards/customer/profile/start-signing',
  CustomerDocusignCompleteSigning = '/v1/gigsafe/dashboards/customer/profile/complete-signing',
  CustomerDocusignDeclineSigning = '/v1/gigsafe/dashboards/customer/profile/decline-signing',

  CustomerStitchStartFlow = '/v1/gigsafe/dashboards/customer/profile/start-stitch-flow',
  CustomerStitchCompletePayment = '/v1/gigsafe/dashboards/customer/profile/complete-stitch-payment',

  FetchSubcontractorCounts = '/v1/gigsafe/dashboards/customer/subcontractor/counts',

  InviteMC = '/v1/gigsafe/dashboards/customer/master-contractor/invite',
  ResendMCInvite = '/v1/gigsafe/dashboards/customer/master-contractor/invite/resend',
  RejectMCInvite = '/v1/gigsafe/dashboards/customer/master-contractor/invite/reject',

  FetchSubcontractorRequests = '/v1/gigsafe/dashboards/customer/subcontractor/pending',
  ApproveSubcontractorRequests = '/v1/gigsafe/dashboards/customer/subcontractor/approve',
  DeclineSubcontractorRequests = '/v1/gigsafe/dashboards/customer/subcontractor/reject',

  FetchMCOnboardings = '/v1/gigsafe/dashboards/customer/master-contractor/invite',
  FetchMCOnboardingsCounts = '/v1/gigsafe/dashboards/customer/master-contractor/invite/counts',

  FetchMCs = '/v1/gigsafe/dashboards/customer/master-contractor/relations',
  FetchMCsCounts = '/v1/gigsafe/dashboards/customer/master-contractor/relation/counts',
  FetchMC = '/v1/gigsafe/dashboards/customer/master-contractor/details',
  UpdateMCExternalId = '/v1/gigsafe/dashboards/customer/master-contractor/external-id',
  MCAddTag = '/v1/gigsafe/tags/:tagId/master-contractor',
  MCDeleteTag = '/v1/gigsafe/tags/:tagId/master-contractor',
  ActivateMC = '/v1/gigsafe/dashboards/customer/master-contractor/activate',
  DeactivateMC = '/v1/gigsafe/dashboards/customer/master-contractor/deactivate',

  FetchMCsWithPendingRequests = '/v1/gigsafe/dashboards/customer/master-contractor/pending-driver-approval',

  FetchMCCustomers = '/v1/gigsafe/dashboards/master-contractor/customer',

  FetchAcceptCustomerInviteDocusignSigningEnvelopeOptions = '/v1/gigsafe/dashboards/master-contractor/customer/signing-envelope-options',
  AcceptCustomerInviteDocusignStartSigning = '/v1/gigsafe/dashboards/master-contractor/customer/start-signing',
  AcceptCustomerInviteDocusignCompleteSigning = '/v1/gigsafe/dashboards/master-contractor/customer/complete-signing',
  AcceptCustomerInviteDocusignDeclineSigning = '/v1/gigsafe/dashboards/master-contractor/customer/decline-signing',

  FetchContractorsPerCustomer = '/v1/gigsafe/dashboards/master-contractor/subcontractors/per-customer',
  FetchContractorsAvailableForAssign = '/v1/gigsafe/dashboards/master-contractor/subcontractors/available',
  AssignContractorsToCustomer = '/v1/gigsafe/dashboards/master-contractor/customer/subcontractors/assign',
  UnassignContractorsFromCustomer = '/v1/gigsafe/dashboards/master-contractor/customer/subcontractors/unassign',

  EndPartnershipWithCustomer = '/v1/gigsafe/dashboards/master-contractor/customer/deactivate',
  DeclineCustomerInvite = '/v1/gigsafe/dashboards/master-contractor/customer/reject',

  FetchMCLiteRelations = '/v1/gigsafe/dashboards/customer/mclite/:contractorId/relations',
  FetchAvailableMCLites = '/v1/gigsafe/dashboards/customer/mclite/:mcLiteId/search',
  FetchAvailableSubcontractorsForMCLite = '/v1/gigsafe/dashboards/customer/mclite/:mcLiteId/subcontractors/search',
  AssignSubcontractorToMCLite = '/v1/gigsafe/dashboards/customer/mclite/:mcLiteId/assign',
  AssignMCLiteToSubcontractor = '/v1/gigsafe/dashboards/customer/mclite/subcontractors/:subcontractorId/assign',
  UnassignSubcontractorToMCLite = '/v1/gigsafe/dashboards/customer/mclite/:mcLiteId/unassign',
  UnassignMCLiteToSubcontractors = '/v1/gigsafe/dashboards/customer/mclite/:mcLiteId/subcontractors/unassign',

  FetchContractorFiles = '/v1/gigsafe/dashboards/contractors/:contractorId/files',
  FetchContractorFile = '/v1/gigsafe/dashboards/contractors/:contractorId/files/:fileId',
  DownloadContractorFile = '/v1/gigsafe/dashboards/contractors/:contractorId/files/:fileId/download',
  CreateContractorFile = '/v1/gigsafe/dashboards/contractors/:contractorId/files',
  UpdateContractorFile = '/v1/gigsafe/dashboards/contractors/:contractorId/files/:fileId',
  DeleteContractorFile = '/v1/gigsafe/dashboards/contractors/:contractorId/files/:fileId',
}
